module.exports = __webpack_public_path__ + "static/media/randomBoxOpenImg.1c9b0ca4.png";